var map = {
	"./कुलपति.jpg": 3845,
	"./कुलसचिव.jpg": 9988,
	"./डॉ कुलदीप सिंह (धर्मशास्त्र विभाग).jpeg": 1608,
	"./डॉ चन्द्रकान्त (ज्योतिष विभाग).jpg": 5690,
	"./डॉ. अखिलेश कुमार मिश्र, विभागाध्यक्ष (वेद).jpg": 4584,
	"./डॉ. कृष्ण चन्द्र पाण्डे (विभागाध्यक्ष, हिन्दू अध्ययन).JPG": 1969,
	"./डॉ. गोविन्द बल्लभ (ज्योतिष विभाग).JPG": 1572,
	"./डॉ. जगत नारायण.JPG": 3154,
	"./डॉ. देवेन्द्र सिंह (योग विभाग).jpg": 405,
	"./डॉ. नरेश शर्मा (विभागाध्यक्ष, ज्योतिष विभाग).jpg": 1366,
	"./डॉ. नवीन शर्मा (ज्योतिष विभाग).jpg": 2122,
	"./डॉ. रामानन्द मिश्र (साहित्य विभाग).jpg": 7290,
	"./डॉ. विनय गोपाल त्रिपाठी (दर्शन विभाग).JPG": 6582,
	"./डॉ. शर्मिला (व्याकरण विभाग).jpg": 2334,
	"./डॉ. सुरेन्द्र पाल वत्स (विभागाध्यक्ष, व्याकरण).jpg": 6738,
	"./डॉ. हरीश कुमार (हिन्दु अध्ययन).jpg": 2835,
	"./परीक्षा नियन्त्रक.jpg": 3402,
	"./राज्यपाल.jpg": 3528,
	"./लोकपाल.jpg": 6632,
	"./वित्ताधिकारी.jpg": 2376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9562;